import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button, Paper, Title, Text, TextInput, PasswordInput, Stack, Alert } from "@mantine/core"
import { IconAlertCircle } from "@tabler/icons-react"
import { useUserStore } from "../stores/userStore"

export function LoginForm() {
  const [error, setError] = useState(null)
  const [pending, setPending] = useState(false)
  const navigate = useNavigate()
  const setUser = useUserStore((state) => state.setUser)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError(null)
    setPending(true)

    const formData = new FormData(event.currentTarget)
    const email = formData.get("email")
    const password = formData.get("password")

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      })

      const data = await response.json()

      if (!response.ok) {
        setError(data.message || "Invalid email or password. Please try again.")
      } else {
        setUser(data.user, data.token)
        navigate("/dashboard")
      }
    } catch (e) {
      setError("An unexpected error occurred. Please try again.")
    } finally {
      setPending(false)
    }
  }

  return (
    <Paper withBorder shadow="md" p={30} radius="md">
      <Title order={2} ta="center" mt="md" mb="xs">
        Login
      </Title>
      <Text c="dimmed" size="sm" ta="center" mb="lg">
        Enter your email below to login to your account
      </Text>

      <form onSubmit={handleSubmit}>
        <Stack>
          <TextInput
            label="Email"
            placeholder="m@example.com"
            required
            name="email"
            id="email"
            type="email"
          />
          <PasswordInput
            label="Password"
            placeholder="Your password"
            required
            name="password"
            id="password"
          />
          
          {error && (
            <Alert icon={<IconAlertCircle size={16} />} title="Error" color="red" variant="light">
              {error}
            </Alert>
          )}
          
          <Button fullWidth mt="xl" type="submit" loading={pending}>
            Login
          </Button>
        </Stack>
      </form>
    </Paper>
  )
}